export var isRow = function (node) {
    return Object.prototype.hasOwnProperty.call(node, 'cells');
};
//# sourceMappingURL=node.js.map